var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1AvControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H1_AV_control_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20H4a4 4 0 00-4 4v24a4 4 0 004 4h16v6H10v4h24v-4H24v-6h16a4 4 0 004-4V24a4 4 0 00-4-4zm0 28H4V24h36v24zM76 15.58L57.79 31H53a4 4 0 00-4 4v7a4 4 0 004 4h4l19 14V15.58zm-4 36.71l-11-8.13V33.75l11-9.29v27.83z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "H1_AV_control_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/H1_AV_control.47bc5743.svg";
export { SvgH1AvControl as ReactComponent };